import placehoder from '/images/banner_placeholder.webp'
import { FC } from 'react'

import { ExternalLink } from '@/pages/Esum/components/ExternalLink'
import { RULES_PDF_URL } from '@/pages/Esum/constants'

import classes from './ForbiddenPrompt.module.css'

export const ForbiddenPrompt: FC = () => (
  <div className={classes.container}>
    <img src={placehoder} alt="" className={classes.image} />

    <div className={classes.content}>
      <div className={classes.infoBox}>
        <h2 className={classes.title}>Ого! Вы стали частью исследования</h2>
        <div className={classes.description}>
          <p className={classes.paragraph}>
            Мы изучаем, как сделать наши акции удобнее для всех. Сейчас вы
            случайно оказались в группе, у которой нет доступа к акции «Поймай
            свою выгоду».
          </p>
          <p className={classes.paragraph}>
            Ваши данные (даже без участия в акции) помогут нам стать лучше.{' '}
          </p>
          <p className={classes.paragraph}>
            Нам очень жаль, если это доставило вам неудобства.{' '}
          </p>
          <span>Смотреть </span>

          <ExternalLink href={RULES_PDF_URL} className={classes.link}>
            Правила Акции
          </ExternalLink>
        </div>
      </div>
    </div>
  </div>
)
